<template>
  <b-card-code title="Floating label inputs">
    <b-card-text class="mb-2">
      <!-- <span>For Flating Label Inputs, need to use </span>
      <code>.form-label-group</code>
      <span> class & add prop </span>
      <code>disabled</code>
      <span> for disabled Floating Label Input.</span> -->
      Floating label inputs are used as the primary input throughout the EasyParcel interfaces for a much more modernized style.
    </b-card-text>

    <!-- <b-row>
      <b-col md="6">
        <div class="form-label-group">
          <b-form-input
            id="floating-label1"
            placeholder="Label Placeholder"
          />
          <label for="floating-label1">Label-placeholder</label>
        </div>
      </b-col>
      <b-col md="6">
        <div class="form-label-group">
          <b-form-input
            placeholder="Disabled-placeholder"
            disabled
          />
          <label for="floating-label-disable">Disabled-placeholder</label>
        </div>
      </b-col>
    </b-row> -->

    <!-- <b-row class="mb-1">
      <b-col md="6">
        <div class="infield-label-group">
          <b-form-input
            id="floating-label2"
            placeholder="Placeholder here"
          />
          <label for="floating-label2">Title here</label>
        </div>
      </b-col>
      <b-col md="6">
        <div class="infield-label-group">
          <b-form-input
            placeholder="Disabled-placeholder"
            disabled
          />
          <label for="floating-label-disable">Disabled-placeholder</label>
        </div>
      </b-col>
    </b-row> -->

    <b-row>
      <b-col md="6">
        <div class="form-label-group infield-float">
          <b-form-input
            id="floating-label3"
            placeholder="Label Placeholder"
          />
          <label for="floating-label3">Label-placeholder</label>
        </div>
      </b-col>
      <b-col md="6">
        <div class="form-label-group infield-float">
          <b-form-input
            placeholder="Disabled-placeholder"
            disabled
          />
          <label for="floating-label-disable">Disabled-placeholder</label>
        </div>
      </b-col>
    </b-row>

    <template #code>
      {{ codeFloatinLabel }}
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BFormInput, BRow, BCol, BCardText,
} from 'bootstrap-vue'
import { codeFloatinLabel } from './code'

export default {
  components: {
    BCardCode,
    BCardText,
    BFormInput,
    BRow,
    BCol,
  },
  data() {
    return {
      codeFloatinLabel,
    }
  },
}
</script>

<style lang="scss">
.form-control { height:46px; }

// .infield-label-group {
//   position: relative;

//   label {
//     position: absolute;
//     top: 10px;
//     left: 14px;
//   }
//   :disabled {
//     label {
//       opacity: 0.7;
//     }
//   }

//   input {
//     height: 66px;
//     padding: 28px 12px 8px !important;

//     // &:hover ~ label,
//     &:focus:not(:placeholder-shown) ~ label {
//       color: #f9278e;
//       transition: all 0.25s ease-in-out;
//     }

//     &:not(:active),
//     &:not(:focus) {
//       &:not(:placeholder-shown) ~ label {
//         color: #f9278e;
//         transition: all 0.25s ease-in-out;
//       }
//     }
//   }
//   .form-control:focus::placeholder {
//     transform: none;
//   }
// }
</style>
